import { render, staticRenderFns } from "./AddTeacher.vue?vue&type=template&id=47fa04f0&scoped=true&"
import script from "./AddTeacher.vue?vue&type=script&lang=js&"
export * from "./AddTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fa04f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47fa04f0')) {
      api.createRecord('47fa04f0', component.options)
    } else {
      api.reload('47fa04f0', component.options)
    }
    module.hot.accept("./AddTeacher.vue?vue&type=template&id=47fa04f0&scoped=true&", function () {
      api.rerender('47fa04f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/teachers/AddTeacher.vue"
export default component.exports